export const actForm = 
{
    "logoPosition": "right",
    "focusFirstQuestionAutomatic": false,
    "pages": [
     {
      "name": "page1",
      "elements": [
       {
        "type": "panel",
        "name": "panel2",
        "elements": [
         {
          "type": "text",
          "name": "account_info[first_name]",
          "title": "FIRST NAME",
          "isRequired": true
         },
         {
          "type": "text",
          "name": "account_info[last_name]",
          "title": "LAST NAME",
          "isRequired": true
         },
         {
          "type": "text",
          "name": "account_info[mobile_number]",
          "title": "MOBILE NUMBER",
          "isRequired": true
         },
         {
          "type": "text",
          "name": "account_info[birth_date]",
          "title": "BIRTHDATE",
          "inputType": "date",
          "autocomplete": "name",
          "isRequired": true
         },
         {
            "type": "checkbox",
            "name": "account_info[opt_in_sms]",
            "title": " ",
            "choices": [
             {
              "value": "yes",
              "text": "Opt-In for Text Message Alerts"
             }
            ]
           },
  
         {
          "type": "text",
          "name": "account_info[permanent_address]",
          "title": "PERMANENT ADDRESS",
          "isRequired": true,
          "visible": false
         },
        //  {
        //   "type": "text",
        //   "name": "account_info[city]",
        //   "title": "CITY",
        //   "isRequired": true
        //  },
        //  {
        //   "type": "text",
        //   "name": "account_info[zip_code]",
        //   "title": "ZIP CODE",
        //   "isRequired": true
        //  }
        ]
       },
       {
        "type": "panel",
        "name": "panel1",
        "elements": [
         {
          "type": "text",
          "name": "account_info[middle_name]",
          "title": "MIDDLE NAME OR INITIAL"
         },
         {
          "type": "text",
          "name": "account_info[suffix]",
          "title": "SUFFIX"
         },
         {
          "type": "text",
          "name": "account_info[email]",
          "title": "EMAIL",
          "isRequired": true
         },
         {
          "type": "text",
          "name": "account_info[ssn]",
          "title": "SOCIAL SECURITY NUMBER",
          "isRequired": true
         },
         {
          "type": "text",
          "name": "account_info[secondary_address]",
          "title": "SECONDARY ADDRESS",
          "visible": false
         },
        //  {
        //   "type": "text",
        //   "name": "account_info[state]",
        //   "title": "STATE",
        //   "isRequired": true
        //  },
         {
          "type": "checkbox",
          "name": "account_info[opt_in_email]",
          "title": " ",
          "choices": [
           {
            "value": "yes",
            "text": "Opt-In for Email Marketing"
           }
          ]
         }        ],
        "startWithNewLine": false
       }
      ]
     }
    ],
    "showNavigationButtons": "none",
    "showTitle": false,
    "showPageTitles": false,
    "showQuestionNumbers": "off",
    "questionDescriptionLocation": "underInput",
    "questionErrorLocation": "bottom",
    "questionsOnPageMode": "singlePage",
    "widthMode": "responsive"
   };